module.exports = __webpack_public_path__ + "img/ife-one-logo-blue.44220f0e.svg";